import { useNavigate } from "react-router-dom";
import { type ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backTo?: string;
  rightAction?: ReactNode;
  showBack?: boolean;
}

export default function PageHeader({
  title,
  subtitle,
  backTo,
  rightAction,
  showBack = true,
}: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-background-200/60">
      <div className="flex items-center h-14 px-4">
        {/* Left: Back button */}
        {showBack ? (
          <button
            onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
            className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer active:bg-background-100 transition-colors flex-shrink-0"
            aria-label="返回"
          >
            <i className="ri-arrow-left-s-line text-foreground-700 text-xl" />
          </button>
        ) : (
          <div className="w-9 flex-shrink-0" />
        )}

        {/* Center: Title */}
        <div className="flex-1 text-center min-w-0">
          <h1 className="text-base font-semibold text-foreground-950 truncate">
            {title}
          </h1>
          {subtitle && (
            <p className="text-[10px] text-foreground-400 mt-0.5">{subtitle}</p>
          )}
        </div>

        {/* Right: Action */}
        <div className="w-9 flex items-center justify-end flex-shrink-0">
          {rightAction || <div className="w-9" />}
        </div>
      </div>
    </div>
  );
}